import { render, staticRenderFns } from "./CandidateListSafetyInstructions.vue?vue&type=template&id=8dd036b8&scoped=true&"
import script from "./CandidateListSafetyInstructions.vue?vue&type=script&lang=js&"
export * from "./CandidateListSafetyInstructions.vue?vue&type=script&lang=js&"
import style0 from "./CandidateListSafetyInstructions.vue?vue&type=style&index=0&id=8dd036b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd036b8",
  null
  
)

export default component.exports